import { render, staticRenderFns } from "./importMeterWaterFee2.vue?vue&type=template&id=bec599b2"
import script from "./importMeterWaterFee2.vue?vue&type=script&lang=js"
export * from "./importMeterWaterFee2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports